import { useAnalytics, useReports } from '@sail/observability';
import { useMemo } from 'react';
import createIntlObject from '../../public/useIntl/createIntlObject';
import useIntlConfig from '../../public/useIntlConfig';
export default function useIntl() {
    const reports = useReports();
    const analytics = useAnalytics();
    const config = useIntlConfig();
    return useMemo(()=>createIntlObject(config, reports, analytics), [
        config,
        reports,
        analytics
    ]);
}

//# sourceMappingURL=useIntl.js.map